export default __webpack_public_path__ + "assets/True Dimensions Template.csv";